import * as React from "react";
import ReactTable from "react-table";
import { FiltroAdminGlosas, Glosa } from "../modelo/AdminGlosas";
import { OverlayTrigger, Tooltip, Glyphicon } from "react-bootstrap";
import ModalAdminGlosa from "./ModalAdminGlosa";


export default class TablaAdminGlosas extends React.Component<TablaAdminGlosasProps, any> {

    columns = [{
        id: "consecutivoServicio",
        Header: "Servicio",
        accessor: "consecutivoServicio",
        Cell: props => (this.renderTexto(props)),
        width: 50
    }, {
        id: "codigoGlosa",
        Header: "Glosa",
        accessor: "codigoGlosa",
        Cell: props => (this.renderTexto(props)),
        width: 50
    }, {
        id: "mensajeUsuario",
        Header: "Mensaje Usuario",
        accessor: "mensajeUsuario",
        Cell: props => (this.renderTexto(props)),
        width: 150
    }, {
        id: "tipoGestion",
        Header: "Tipo Gestion",
        accessor: "tipoGestion",
        Cell: props => (this.renderTexto(props)),
        width: 80
    }, {
        id: "descripcion",
        Header: "Descripción",
        accessor: "descripcion",
        Cell: props => (this.renderTexto(props)),
        width: 140
    }, {
        id: "esBloqueante",
        Header: "Bloqueante",
        accessor: "esBloqueante",
        Cell: props => (this.renderBoolean(props)),
        width: 70
    }, {
        id: "validacion",
        Header: "Validación",
        accessor: "validacion",
        Cell: props => (this.renderTexto(props)),
        width: 150
    }, {
        id: "fechaAlta",
        Header: "Fecha Alta",
        accessor: "fechaAlta",
        Cell: props => (this.renderTexto(props)),
        width: 80
    }, {
        id: "fechaBaja",
        Header: "Fecha Baja",
        accessor: "fechaBaja",
        Cell: props => (this.renderTexto(props)),
        width: 80
    }, {
        id: "dniIngreso",
        Header: "Usuario Ingreso",
        accessor: "dniIngreso",
        Cell: props => (this.renderTexto(props)),
        width: 100
    }, {
        id: "fechaIngresa",
        Header: "Fecha Ingreso",
        accessor: "fechaIngresa",
        Cell: props => (this.renderTexto(props)),
        width: 100
    }, {
        id: "consecutivo",
        Header: "Acción",
        accessor: "consecutivo",
        Cell: props => (this.renderAccion(props)),
        width: 60
    }
    ];

    renderAccion = (props: any) => {
        if (props.original.pendiente) {
            return (
                <button type="button" className="btns btns-glyphicon">
                    <span className="icons-table">
                        <Glyphicon glyph={"transfer"} />
                    </span>
                </button>
            );
        } else {
            return (
                <ModalAdminGlosa
                    consecutivo={props.original.consecutivo}
                    consecutivoServicio={props.original.consecutivoServicio}
                    codigoGlosa={props.original.codigoGlosa}
                    validacion={props.original.validacion}
                    mensajeUsuario={props.original.mensajeUsuario}
                    tipoGestion={props.original.tipoGestion}
                    descripcion={props.original.descripcion}
                    fechaAlta={props.original.fechaAlta}
                    fechaBaja={props.original.fechaBaja}
                    dniIngreso={props.original.dniIngreso}
                    fechaIngresa={props.original.fechaIngresa}
                    esBloqueante={props.original.esBloqueante}
                />
            );
        }
    }

    render() {
        const { glosas, paginas, tamanoPagina, paginaActual } = this.props;
        let numRegistros = 0;

        if (glosas.length < tamanoPagina) {
            numRegistros = glosas.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{glosas.length}</span> Parámetros encontrados
                    </h2>
                </div>
                <ReactTable data={glosas}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable={false}
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const filtroDocumento: FiltroAdminGlosas = {
            servicio: this.props.filtro.servicio,
            codigoGlosa: this.props.filtro.codigoGlosa,
            palabraClave: this.props.filtro.palabraClave,
            tipoGestion: this.props.filtro.tipoGestion,
            tipoFecha: this.props.filtro.tipoFecha,
            fecha: this.props.filtro.fecha,
            complementoFecha: this.props.filtro.complementoFecha,
            snBloqueante: this.props.filtro.snBloqueante,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex,
        };
        this.props.consultaPaginada(filtroDocumento);
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    renderBoolean = (props: any) => {
        const snBloqueante = props.value ? "SI" : "NO" ;
        return (
            <div style={{ marginTop: '10px' }}>
                <span>{snBloqueante}</span>
            </div>
        );
    }

    renderTexto = (props: any) => {
        if (props.value) {
            if (props.value.length > 20) {
                const tooltip = (
                    <Tooltip id="tooltip" className="tooltip-pos" placement="top" >{this.textoToolTip(props.value)}</Tooltip>
                );
                return (
                    <div style={{ marginTop: '10px' }}>
                        <OverlayTrigger placement="top" overlay={tooltip}>
                            <span>{props.value}</span>
                        </OverlayTrigger>
                    </div>
                );
            }
            return (
                <div style={{ marginTop: '10px' }}>
                    <span>{props.value}</span>
                </div>
            );
        }
        return (props.value);
    }

    textoToolTip = (texto : string) => {
        if(texto.length > 100){
            return texto.substr(0, 100).concat('...');
        }
        return texto;
    }
}

interface TablaAdminGlosasProps {
    glosas: Array<Glosa>
    filtro: FiltroAdminGlosas,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    consultaPaginada?: (filtro: FiltroAdminGlosas) => void;
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_glosas/componentes/TablaAdminGlosas.tsx